import React, { useState, useEffect, useReducer, useRef } from 'react';
// import { api, APIS } from '@/api';
import { SFuncModal } from 'shj-components'
import { Form, Button, Select, Divider, Row, Col, message, Input, DatePicker, Table, Space, Popconfirm } from 'antd';
// import { ruledDetailedFn } from '@/pages/receiptRulesManagement/components/ruledDetailed';
import BusinessMatters from './businessMatters'; //业务事项
import SubRulesModel from './subRulesModel'; //子规则modal
import dayjs from 'dayjs';
import styles from './index.module.less';
import { isNil, cloneDeep } from 'lodash-es';
import { ruleConfigDetails, ruleConfigSave, businessMattersDetails, ruleConfigDtlDelete } from '@/services/integrationConfig'
const TextArea = Input.TextArea;
// const subListRef = useRef<any>();

// @ts-ignore
export function modalAddOrEditFn({ fn, ...rest }) {
  const onClose = () => {
    dialog.destroy();
  };
  const dialog = SFuncModal({
    title: `${rest?.id ? '编辑规则' : '新增规则'}`,
    width: 1240,
    vanish: true,
    forceRender: true,
    content: <ModalAddOrEditDom onClose={onClose} fn={fn} {...rest} />,
  });

  return dialog;
}
/**
 * moment类型转日期
 * @param  momentVal moment类型的日期 默认格式 年-月-日
 */
const momentToDate = (momentVal: any, format = 'YYYY-MM-DD') => {
  // if (!moment.isMoment(momentVal)) return;
  return momentVal ? dayjs(momentVal).format(format) : null;
};

/**
 * 日期转moment类型
 * @param dateVal 字符串的日期 默认格式 年-月-日
 */
const dateToMoment = (dateVal: string, format = 'YYYY-MM-DD') => {
  console.log(dateVal,format)
  return dateVal ? dayjs(dateVal, format) : null;
};

// @ts-ignore
const ModalAddOrEditDom = ({ onClose, fn, ...rest }) => {
  const [form] = Form.useForm();
  const [openData, setOpenData] = useState(false);
  const [addOrEditFooterLoading, setAddOrEditFooterLoading] = useState(false);
  const [subRuleDetails, setSubRuleDetails] = useState({}); //子规则信息
  const [ruleConfigDtlList, setRuleConfigDtlList] = useState([]); //子规则列表
  const [currentBusinessMatters, setCurrentBusinessMatters]: any = useState({}); //当前选中的业务事项

  const initFn = () => {
    console.log(rest);
    if (rest?.id) {
      // 获取详情
      getRuleDetails(rest?.id);

      const {
        id,
        code,
        name,
        businessMattersId,
        businessMatters,
        status,
        enableTime,
        stopTime,
        remark,
        description,
        ruleConfigDtlList,
      } = rest;
      getBusinessMattersDetails(businessMattersId, { id: businessMattersId, businessMattersId, businessMatters });
      form.setFieldsValue({
        id,
        code,
        name,
        businessMattersId,
        businessMatters,
        status,
        enableTime: dateToMoment(dayjs(enableTime).format('YYYY-MM-DD HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss'),
        stopTime: dateToMoment(dayjs(stopTime).format('YYYY-MM-DD HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss'),
        remark,
        description,
      });
      // // 业务事项
      // setCurrentBusinessMatters({
      //   id: businessMattersId,
      //   name: businessMatters,
      // });
      if (isValidArray(ruleConfigDtlList)) {
        const tempList = ruleConfigDtlList.map((item: any, index: number) => {
          return {
            ...item,
            sortIndex: index + 1,
          };
        });
        setRuleConfigDtlList(tempList);
      }
    } else {
      form.setFieldsValue({
        status: true,
        enableTime: dateToMoment(dayjs().format('YYYY-MM-DD HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss'),
        stopTime: dateToMoment('2099-01-01 00:00:00', 'YYYY-MM-DD HH:mm:ss'),
      });
    }
  };
  useEffect(() => {
    initFn();
  }, []);

  const getRuleDetails = (id: any) => {
    ruleConfigDetails(id).then((resp: any) => {
      const {
        id,
        code,
        name,
        businessMattersId,
        businessMatters,
        status,
        enableTime,
        stopTime,
        remark,
        description,
        ruleConfigDtlList,
      } = resp;
      getBusinessMattersDetails(businessMattersId, { id: businessMattersId, businessMattersId, businessMatters });
      form.setFieldsValue({
        id,
        code,
        name,
        businessMattersId,
        businessMatters,
        status,
        enableTime: dateToMoment(dayjs(enableTime).format('YYYY-MM-DD HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss'),
        stopTime: dateToMoment(dayjs(stopTime).format('YYYY-MM-DD HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss'),
        remark,
        description,
      });
      // // 业务事项
      // setCurrentBusinessMatters({
      //   id: businessMattersId,
      //   name: businessMatters,
      // });
      if (isValidArray(ruleConfigDtlList)) {
        const tempList = ruleConfigDtlList.map((item: any, index: number) => {
          return {
            ...item,
            sortIndex: index + 1,
          };
        });
        setRuleConfigDtlList(tempList);
      }
    });
  };

  // 重置
  const onReset = () => {
    form.resetFields();
  };
  const look = (obj = {}) => {
    // ruledDetailedFn({
    //   fn: () => {},
    //   ...obj,
    // });
  };
  // 提交
  const onSaveRule = (values: object) => {
    // const { id } = rest;
    const { id } = form.getFieldsValue();
    const newValues: any = { ...values };
    newValues.enableTime = momentToDate(newValues.enableTime, 'YYYY-MM-DD HH:mm:ss');
    newValues.stopTime = momentToDate(newValues.stopTime, 'YYYY-MM-DD HH:mm:ss');
    // newValues.ruleConfigDtlList = []; //子规则
    setAddOrEditFooterLoading(true);
      ruleConfigSave({ ...newValues, ...(id && { id }) }).then((resp: any) => {
        setAddOrEditFooterLoading(false);
        message.info(resp?.message || '操作成功');

        if (isNil(id)) {
          form.setFieldsValue({
            id: resp,
          });
        } else {
          onClose();
        }

        fn && fn();
      })
      .finally(() => {
        setAddOrEditFooterLoading(false);
      });
  };

  const onOkData = (rows: any) => {
    console.log(rows);
    const obj = rows[0];
    console.log(obj);
    setOpenData(false);

    form.setFieldsValue({
      businessMatters: obj?.name,
      // businessMattersCode: obj?.code,
      businessMattersId: obj?.id,
    });
    // 通过业务事项id 获取
    // setCurrentBusinessMatters(obj);
    getBusinessMattersDetails(obj?.id, { ...obj });
  };

  const getBusinessMattersDetails = (businessMattersId: any, businessMattersData: any) => {
    businessMattersDetails(businessMattersId).then((resp: any) => {
        console.log(resp);
        if (isNil(resp)) return;

        const { businessParamJson } = resp;
        setCurrentBusinessMatters({ ...businessMattersData, businessParamJson });
      })
      .finally(() => {});
  };

  // const addBtnDisabled = ()=>{
  //   let businessMattersId
  // }
  const onCancelData = () => {
    setOpenData(false);
  };

  /**
   * 是否为有效的数组
   * @param arr 数组
   */
  const isValidArray = (arr: any[]) => {
    return arr && Array.isArray(arr) && arr.length > 0 ? true : false;
  };

  /**
   * 渲染Select组件的下拉项Option
   * @param list 数组 or map={A:'学生',B:'老师'}
   * @param _key 指定的option Key 默认当前list的key
   * @param _value 指定的option Value  默认当前list的value
   */
  const renderSelectOpt = (list: any[], _key: string, _value: string) => {
    // 数组类型
    if (Array.isArray(list)) {
      return (list || []).map((item, index) => (
        <Select.Option key={index} value={item[_key] || item.key} dataitem={item}>
          {item[_value] || item.value}
        </Select.Option>
      ));
    }
    //map类型
    if (typeof list === 'object' && list !== null) {
      return Object.keys(list).map((item, index) => (
        <Select.Option value={item} key={index} dataitem={item}>
          {list[item]}
        </Select.Option>
      ));
    }
  };
  const disabledStopDate = (current: any) => {
    //启用时间后一天
    // const enableTime = moment(form.getFieldValue('enableTime')).add('1', 'days');
    const enableTime = form.getFieldValue('enableTime');
    return current && current < enableTime;
  };
  const disabledEnableTime = (current: any) => {
    const stopTime = form.getFieldValue('stopTime');
    return current && current > stopTime;
  };
  const formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
  };
  const formItemLayout2 = {
    labelCol: { span: 2 },
    wrapperCol: { span: 22 },
  };
  const statusList = [
    { key: true, value: '启用' },
    { key: false, value: '禁用' },
  ];
  const dateFormat = 'YYYY-MM-DD HH:mm:ss';
  const statusListOpt = renderSelectOpt(statusList, 'key', 'value');

  // 新增子规则
  const addSubRule = (type: string, record = {}) => {
    console.log(currentBusinessMatters);
    const { id, businessMattersId, businessMatters, enableTime, stopTime } = form.getFieldsValue();
    const ruleForm = {
      id,
      businessMattersId,
      businessMatters,
      ruleEnableTime: enableTime,
      ruleStopTime: stopTime,
    };
    setSubRuleDetails({
      ...subRuleDetails,
      // busMattersId: '1', //业务事项Id
      businessMattersData: currentBusinessMatters,
      businessMattersId: currentBusinessMatters?.id, //业务事项id
      visible: true,
      // ruleForm: form,
      ruleForm,
      type,
      currentItem: record,
    });

    return;
  };
  const onFromSubmit = (values: any) => {
    console.log(values);
  };
  const onCancelSubRule = (laodRule?: boolean) => {
    setSubRuleDetails({
      ...subRuleDetails,
      visible: false,
    });
    if (laodRule) {
      const { id } = form.getFieldsValue();
      getRuleDetails(id);
    }
  };

  const columns: any = [
    {
      title: '序号',
      dataIndex: 'sortIndex',
      align: 'center',
      ellipsis: true,
    },
    {
      title: '子规则编码',
      dataIndex: 'code',
      align: 'center',
      ellipsis: true,
    },
    {
      title: '子规则名称',
      dataIndex: 'name',
      align: 'center',
      ellipsis: true,
    },
    {
      title: '状态',
      dataIndex: 'status',
      align: 'center',
      ellipsis: true,
      render: (_text: any) => {
        return <>{!isNil(_text) ? (_text ? '启用' : '禁用') : '-'}</>;
      },
    },
    {
      title: '启用时间',
      dataIndex: 'enableTime',
      itemType: "dateTime",
      align: 'center',
      ellipsis: true,
      render: (text: any) => {
        return momentToDate(text)
      }
    },
    {
      title: '停用时间',
      dataIndex: 'stopTime',
      itemType: "dateTime",
      align: 'center',
      ellipsis: true,
      render: (text: any) => {
        return momentToDate(text)
      }
    },
    {
      title: '操作',
      dataIndex: 'action',
      align: 'center',
      render: (_text: any, _record: any, _index: any) => {
        return (
          <Space>
            <Button
              size="small"
              type="primary"
              onClick={() => addSubRule('edit', _record)}
              disabled={rest.type == 'view'}
            >
              编辑
            </Button>
            <Button size="small" type="primary" onClick={() => addSubRule('view', _record)}>
              查看
            </Button>
            <Popconfirm
              title={'确定删除该项吗？'}
              okText="是"
              cancelText="否"
              onConfirm={() => _onConfirmDelSubRule(_record, _index)}
              disabled={rest.type == 'view'}
            >
              <Button size="small" danger disabled={rest.type == 'view'}>
                删除
              </Button>
            </Popconfirm>
          </Space>
        );
      },
    },
  ];

  const delSubRule = (index: number) => {
    const list = cloneDeep(ruleConfigDtlList);
    list.splice(index, 1);
    const nullArr: any = [];
    let newList: any = list.concat(nullArr);
    newList = (newList || []).map((item: any, ind: number) => {
      return {
        ...item,
        sortIndex: ind + 1,
      };
    });
    setRuleConfigDtlList(newList);
  };

  const _onConfirmDelSubRule = (record: any, index: number) => {
    if (record?.id) {
      ruleConfigDtlDelete(record?.id).then((resp: any) => {
          message.info(resp?.message || '删除成功');
          delSubRule(index);
        })
        .finally(() => {});
    }
  };

  return (
    <div style={{ padding: 15 }}>
      <Form form={form} onFinish={onSaveRule} layout={'vertical'} {...formItemLayout}>
        <Row>
          <Col span={8}>
            <Form.Item label="规则编码" name="code" rules={[{ required: false }]}>
              <Input placeholder="自动生成" disabled />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="规则说明" name="name" rules={[{ required: true }]}>
              <Input placeholder="请输入规则说明" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="规则id" name="id" rules={[{ required: false }]} noStyle hidden>
              <Input disabled />
            </Form.Item>
            <Form.Item label="业务事项id" name="businessMattersId" rules={[{ required: true }]} noStyle hidden>
              <Input disabled />
            </Form.Item>
            <Form.Item label="业务事项" name="businessMatters" rules={[{ required: true }]}>
              <Input.Search
                readOnly
                placeholder={'请选择业务事项'}
                enterButton="请选择"
                onSearch={() => setOpenData(true)}
                disabled={rest.type == 'view'}
                className={styles.disabledInput}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={8}>
            <Form.Item label="状态" name="status" rules={[{ required: true }]}>
              <Select
                placeholder="请选择状态"
                onChange={(v: boolean) => {
                  const { enableTime } = form.getFieldsValue();
                  if (v) {
                    form.setFieldsValue({
                      stopTime: dayjs('2099-01-01 00:00:00', 'YYYY-MM-DD HH:mm:ss'),
                    });
                  } else {
                    //当前日期
                    const currentTime = dateToMoment(
                      `${dayjs().format('YYYY-MM-DD')} 00:00:00`,
                      'YYYY-MM-DD HH:mm:ss',
                    );
                    //启用时间是否在当前日期之后
                    const enableTimeAfter = dayjs(enableTime).isAfter(dayjs(dayjs().format('YYYY-MM-DD')), 'day');
                    //启用时间在当前日期后，则取当前日期
                    const enableTimeNew = enableTimeAfter ? currentTime : enableTime;

                    form.setFieldsValue({
                      enableTime: enableTimeNew,
                      stopTime: currentTime,
                    });
                  }
                }}
              >
                {statusListOpt}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="启用时间" name="enableTime" rules={[{ required: true }]}>
              <DatePicker
                style={{ width: '100%' }}
                format={dateFormat}
                clearIcon={false}
                onChange={(date: any) => {
                  const temp = momentToDate(date, 'YYYY-MM-DD HH:mm:ss');
                  form.setFieldsValue({
                    enableTime: dateToMoment(`${temp} 00:00:00`, dateFormat),
                  });
                }}
                disabledDate={disabledEnableTime}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="停用时间" name="stopTime" rules={[{ required: true }]}>
              <DatePicker
                style={{ width: '100%' }}
                format={dateFormat}
                clearIcon={false}
                disabledDate={disabledStopDate}
              />
            </Form.Item>
          </Col>
        </Row>
        <Col span={24}>
          <Form.Item
            label="备注"
            name="remark"
            {...formItemLayout2}
            rules={[{ required: false, message: '请选输入备注' }]}
          >
            <TextArea rows={3} autoSize={false} maxLength={600} />
          </Form.Item>
        </Col>
        <Form.Item shouldUpdate noStyle>
          {({ getFieldValue }) => {
            return (
              !isNil(getFieldValue('id')) && (
                <div>
                  <Space>
                    <Button
                      type="primary"
                      size="small"
                      onClick={() => addSubRule('add')}
                      disabled={isNil(currentBusinessMatters?.id) || rest.type == 'view'}
                    >
                      新增子规则
                    </Button>
                  </Space>
                  <Divider style={{ margin: '12px 0' }} />
                  <Table columns={columns} dataSource={ruleConfigDtlList || []} rowKey={'id'} size="small" bordered />
                </div>
              )
            );
          }}
        </Form.Item>

        <Row>
          <Divider style={{ margin: '10px 0' }} />
          <Col span={24} style={{ textAlign: 'right' }}>
            {/* <Button htmlType="button" onClick={onReset} disabled={rest.type == 'view'}>
              重置
            </Button> */}
            <Button htmlType="button" onClick={onClose} style={{ marginLeft: '8px' }}>
              取消
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              style={{ margin: '0 8px' }}
              loading={addOrEditFooterLoading}
              disabled={rest.type == 'view'}
            >
              提交
            </Button>
          </Col>
        </Row>
      </Form>
      {/*  业务事项*/}
      <BusinessMatters
        open={openData}
        config={form}
        type={'radio'}
        title={'业务事项'}
        showMode="drawer"
        onOk={onOkData}
        onCancel={onCancelData}
      />
      <SubRulesModel props={subRuleDetails} onFromSubmit={onFromSubmit} onCancelSubRule={onCancelSubRule} />
    </div>
  );
};
